export default __webpack_public_path__ + "static/media/43_2_0.fafe97b8.png";